import styles from './StatCard.module.css';

function StatCard({ label, value, trend, trendSub, meta }) {
  return (
    <div className={styles.card}>
      <div className={styles.label}>{label}</div>
      <div className={styles.value}>{value}</div>
      {trend && (
        <div className={styles.trend}>
          {trend}
          {trendSub && <span className={styles.trendSub}> {trendSub}</span>}
        </div>
      )}
      {meta && <div className={styles.meta}>{meta}</div>}
    </div>
  );
}

export default StatCard;
